import http from "../http-common";

class RAPSHighlightsService {
  getAllPromotions(path?: string) {
    return http.get(`/promotions?pathName=${path}`);
  }
}

export default new RAPSHighlightsService();
